import { DataBean } from "../DataBean";

export class CostingCenterValue extends DataBean {


   

    public async getCostingCenterValueCatalog(idCostingCenterMethod:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getCostingCenterValueCatalog_Number", [idCostingCenterMethod]);
    }

    public async addCostingCenterValue(idCostingCenterMethod:any,idCostingCenter:any,percentValue:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.accountant.CostingCenterValue_addCostingCenterValue_Number_Number_Number", [idCostingCenterMethod,idCostingCenter,percentValue]);
    }
}